import axios from "axios";
import {
  BASE_URL,
  SCHEME_BASE_URL,
  BOOKING_BASE_URL,
  REACT_Certificate_URL,
} from "./adminUrlConfig";
import { attemptTokenRefresh, clearAuthAndRedirect } from "../utils/authUtils";

const HEADERS = {
  "Api-Version": "v1",
  responseType: "application/json",
  "Content-Type": "application/json",
  Accept: "application/json",
};

const HEADERSMULTIPART = {
  "Api-Version": "v1",
  responseType: "application/json",
};

export const UnAuthApiService = axios.create({
  baseURL: BASE_URL,
  headers: HEADERS,
});

export const ApiService = axios.create({
  baseURL: BASE_URL,
  headers: HEADERS,
});

export const UserCertificate = axios.create({
  baseURL: REACT_Certificate_URL,
});

export const SchemeApiService = axios.create({
  baseURL: SCHEME_BASE_URL,
  headers: HEADERS,
});

export const AssesmentApiService = axios.create({
  baseURL: process.env.REACT_APP_ASSESMENT_API_URL,
  headers: HEADERS,
});

export const BookingApiService = axios.create({
  baseURL: BOOKING_BASE_URL,
  headers: HEADERS,
});

export const HostelApiService = axios.create({
  baseURL: process.env.REACT_APP_HOSTEL_API_URL,
  headers: HEADERS,
  withCredentials: true,
});

export const FileUploadService = axios.create({
  baseURL: BASE_URL,
  headers: HEADERSMULTIPART,
});

export const SchemeFileUploadService = axios.create({
  baseURL: SCHEME_BASE_URL,
  headers: HEADERSMULTIPART,
});

// Shared refresh state — prevents concurrent refresh storms
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    error ? reject(error) : resolve(token);
  });
  failedQueue = [];
};

const attachRequestInterceptor = (instance, multipart = false) => {
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("access_token_admin");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      if (multipart) {
        delete config.headers["Content-Type"];
      }
      return config;
    },
    (error) => Promise.reject(error),
  );
};

const attachResponseInterceptor = (instance) => {
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error?.response?.status === 401 && !originalRequest?._retry) {
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return instance(originalRequest);
            })
            .catch((err) => Promise.reject(err));
        }

        originalRequest._retry = true;
        isRefreshing = true;

        try {
          const token = await attemptTokenRefresh();
          processQueue(null, token);
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return instance(originalRequest);
        } catch (refreshErr) {
          processQueue(refreshErr, null);
          clearAuthAndRedirect();
          return Promise.reject(refreshErr);
        } finally {
          isRefreshing = false;
        }
      }

      return error?.response;
    },
  );
};

attachRequestInterceptor(ApiService);
attachRequestInterceptor(FileUploadService, true);
attachRequestInterceptor(SchemeApiService);
attachRequestInterceptor(SchemeFileUploadService, true);
attachRequestInterceptor(AssesmentApiService);
attachRequestInterceptor(HostelApiService);
attachRequestInterceptor(BookingApiService);

attachResponseInterceptor(ApiService);
attachResponseInterceptor(FileUploadService);
attachResponseInterceptor(SchemeApiService);
attachResponseInterceptor(SchemeFileUploadService);
attachResponseInterceptor(AssesmentApiService);
attachResponseInterceptor(HostelApiService);
attachResponseInterceptor(BookingApiService);
